/**
 * Base composable for notification creation
 * Provides shared utilities for all notification creators
 */
export function useNotificationCreatorBase() {
  const notificationCore = useNotificationCore()
  const membersStore = useMembersStore()
  const subkrewesStore = useSubKrewesStore()

  /**
   * Get member data with proper error handling
   */
  const getMember = async (memberId: string): Promise<Member> => {
    const member = await membersStore.fetchMember(memberId)
    if (!member) {
      throw new Error(`Member not found: ${memberId}`)
    }
    return member
  }

  /**
   * Get SubKrewe data with proper error handling
   */
  const getSubKrewe = (subkreweId: string): SubKrewe => {
    const subkrewe = subkrewesStore.getSubkreweById(subkreweId)
    if (!subkrewe) {
      throw new Error(`SubKrewe not found: ${subkreweId}`)
    }
    return subkrewe
  }

  /**
   * Get acting user info with error handling
   */
  const getActingUserInfo = async (userId: string): Promise<{ name: string, type: string }> => {
    try {
      const user = await membersStore.fetchMember(userId)
      if (user) {
        const type = user.member_type === 'captain'
          ? 'Captain'
          : (user.roles?.admin ? 'Admin' : 'Member')
        return {
          name: user.name,
          type,
        }
      }
    }
    catch (error) {
      console.warn(`Could not fetch user info for ${userId}:`, error)
    }

    return { name: 'System', type: 'System' }
  }

  return {
    notificationCore,
    membersStore,
    subkrewesStore,
    getMember,
    getSubKrewe,
    getActingUserInfo,
  }
}
